import { Anchor } from '@/components/ui/anchor';
import { MoviePoster } from '@/types/movie-poster';

type NoShowtimeContentComponentProps = {
  dataLinkCategory?: string;
  dataLinkName?: string;
  moviePoster: MoviePoster;
};

export const NoShowtimeContentComponent = ({ dataLinkCategory, dataLinkName, moviePoster }: NoShowtimeContentComponentProps): React.JSX.Element => {
  return (
    <div className="w-full min-[1200px]:w-auto">
      <Anchor className="w-full h-[46px] text-base min-[1200px]:w-[250px]"
        data-test="link-movie-details-no-showtimes"
        dataLinkCategory={dataLinkCategory}
        dataLinkName={dataLinkName}
        href={moviePoster.movieUrl}
      >
        Movie Details
      </Anchor>
    </div>
  );
};
